import React from "react";
import {AElement} from "../../models/elements/AElement";
import DataFilledManually from "./DataFilledManually";
import {EElementType, elementsNameKey} from "../../models/utils/EElementType";
import {WithTranslation, withTranslation} from "react-i18next";
import {EnergyBox} from "../../models/elements/EnergyBox";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Element to display.
     */
    element: AElement
}

/**
 * Displays the attributes of an element.
 * @author Alizée Grand
 * @version 1.1
 * @creation 31/05/2022
 * @last_update 11/07/2022
 **/
class DisplayElement extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        /**
         * If the displayed element is of type EnergyBox, returns the markup to display the LoRa identifier.
         * @return {JSX.Element}
         */
        const getEnergyBoxElement = () => {
            let display = <React.Fragment/>;
            if(this.props.element.type === EElementType.EnergyBox) {
                const cast = this.props.element as EnergyBox;
                display = (
                    <span><br/><b>{getTranslation("display.element.lora")}</b> : {cast.eLoraId}</span>
                );
            }
            return display;
        }

        return (

            <React.Fragment>
                {
                    !this.props.element.isScanned ? <DataFilledManually/> : ""
                }
                <span><b>{getTranslation("display.element.type")}</b> : {getTranslation(elementsNameKey[this.props.element.type])}</span>
                <br/>
                <span><b>{getTranslation("display.element.serial")}</b> : {this.props.element.serialNumber}</span>
                {
                    getEnergyBoxElement()
                }
            </React.Fragment>

        );

    };

}

export default withTranslation()(DisplayElement);
